<template>
<div class='container-center-horizontal-melody'>
    <span class='color-melody title tamanhotitle'>{{$t('games.melody.gamemode')}}</span>
    <div class='button-list-gamemode animated-choosegamelist'>
        <div class='space-gamemode'>
            <span class='fig-gamemode'
            :class="{ 'sel-gamemode-melody' : selected == 'Spain' }"
            @click="onClick('Spain')">
                <img :src="require('@/assets/gamemode/es.svg')">
                <span class="color-melody mode tamanho0">{{$t('games.shared.gamemodes.spain')}}</span>
            </span>

            <span class='fig-gamemode gamemode-2'
            :class="{ 'sel-gamemode-melody' : selected == 'Italy' }"
            @click="onClick('Italy')">
                <img :src="require('@/assets/gamemode/it.svg')">
                <span class="color-melody mode tamanho0">{{$t('games.shared.gamemodes.italy')}}</span>
            </span>

            <span class='fig-gamemode gamemode-3'
            :class="{ 'sel-gamemode-melody' : selected == 'Portugal' }"
            @click="onClick('Portugal')">
                <img :src="require('@/assets/gamemode/pt.svg')">
                <span class="color-melody mode tamanho0">{{$t('games.shared.gamemodes.portugal')}}</span>
            </span>

            <span class='fig-gamemode gamemode-poli'
            :class="{ 'sel-gamemode-melody' : selected == 'All' }"
            @click="onClick('All')">
                <img :src="require('@/assets/gamemode/es.svg')">
                <img :src="require('@/assets/gamemode/it.svg')">
                <img :src="require('@/assets/gamemode/pt.svg')">
                <span class="color-melody mode tamanho0">{{$t('games.shared.gamemodes.all')}}</span>
            </span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "ChooseGameMode",
    emits: ['chooseGM'],
    data() {
        return {
            selected: ''
        }
    },
    methods: {
        onClick(num) {
            this.selected = num;
            this.$emit('chooseGM', num);
        }
    }
};
</script>

<style>
.color-melody{
    color:#3FA535;
}
.colortext-melody{
    color:#456E22;
}
.title-melody {

    animation: movetitlemelody 0.5s ease-in-out;
}
@keyframes movetitlemelody {
  0% {top:-5%;}
  100% {top:8%;}
}


.button-list-gamemode {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-evenly;
    flex-direction: row;
}
.space-gamemode{
    width: 88%;
    display: flex;
    justify-content: space-evenly;
}
.animated-choosegamelist{
    margin-top:0;
    animation: movecontainerchoosegame 0.5s ease-in-out;
}
@keyframes movecontainerchoosegame {
  0% {margin-top:10%;}
  100% {margin-top:0;}
}

.fig-gamemode {
    background: rgba(255, 255, 255, 0.7);
    border-radius: 30px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    display: flex;
    padding: 3.5% 2.5% 1% 2.5%;
    width: 16%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/*.gamemode-2 {
    padding-left: 2%;
    padding-right: 2.4%;
}
.gamemode-3{
    padding-left: 2%;
    padding-right: 2.4%;
}*/

 .fig-gamemode >img {
    width: 70%;
}

.gamemode-poli {
    padding:1.5% 2% 0.9% 2%;
}

.gamemode-poli > img {
    margin: 2%;
    width: 25%;
}

.sel-gamemode-melody {
    box-shadow: 0 0 0 7px #3FA535;
}
.mode{
    font-family: Omnes;
    font-style: Regular;
    margin-top: 9%;
    margin-bottom: 4%;
    text-align: Center;
}


@media only screen and (max-width: 480px) {
    .title-melody {
        font-size: 1.2rem;
    }
   .gamemode-poli > img {
        padding: 0 4%;
    }
    .fig-gamemode {
        border-radius: 17px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 3px #3FA535;
    }
}

@media only screen and (min-width: 480px) and (max-width: 550px) {
   .title-melody {
         font-size: 1.4rem;
    }
    .fig-gamemode {
        border-radius: 20px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 4px #3FA535;
    }
}

@media only screen and (min-width: 550px) and (max-width: 630px){
   .title-melody {
         font-size: 1.6rem;
    }
    .fig-gamemode {
        border-radius: 23px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 5px #3FA535;
    }
}
@media only screen and (min-width: 630px) and (max-width: 718px){
    .title-melody {
         font-size: 1.8rem;
    }
    .fig-gamemode {
        border-radius: 26px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 6px #3FA535;
    }
}
@media only screen and (min-width: 718px) and (max-width: 806px) {
   .title-melody {
         font-size: 2rem;
    }
    .fig-gamemode {
        border-radius: 29px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 7px #3FA535;
    }
}
@media only screen and (min-width: 806px) and (max-width: 1024px) {
   .title-melody {
         font-size: 2.2rem;
    }
    .fig-gamemode {
        border-radius: 32px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 8px #3FA535;
    }
}
@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    .title-melody {
         font-size: 2.4rem;
    }
    .fig-gamemode {
        border-radius: 35px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 9px #3FA535;
    }

}
@media only screen and (min-width: 1200px) and (max-width: 1366px) {
    .title-melody {
         font-size: 2.6rem;
    }
    .fig-gamemode {
        border-radius: 45px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 10px #3FA535;
    }

}
@media only screen and (min-width: 1366px) and (max-width: 1540px){
    .title-melody {
         font-size: 2.8rem;
    }
    .fig-gamemode {
        border-radius: 55px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 11px #3FA535;
    }

}
@media only screen and (min-width: 1540px) and (max-width: 1680px){
    .title-melody {
         font-size: 3rem;
    }
    .fig-gamemode {
        border-radius: 65px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 12px #3FA535;
    }

}
@media only screen and (min-width: 1680px) and (max-width:2350px){
    .title-melody {
         font-size: 3.2rem;
    }
    .fig-gamemode {
        border-radius: 70px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 13px #3FA535;
    }
}
@media only screen and (min-width: 2350px) {
    .title-melody {
         font-size: 3.4rem;
    }
    .fig-gamemode {
        border-radius: 80px;
    }
    .sel-gamemode-melody {
        box-shadow: 0 0 0 14px #3FA535;
    }

}

</style>
